import { useContext } from 'react';

import type { SelectMenuContextProps } from '../contexts/SelectMenuContext.js';
import { SelectMenuContext } from '../contexts/SelectMenuContext.js';

export const useSelectMenuContext = (): SelectMenuContextProps =>
  useContext(SelectMenuContext);
